var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcJoinRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#092E5E",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3407 38.0423L25.8922 36.5938C25.4938 36.1954 25.3532 35.6188 25.5313 35.0845C25.6719 34.6673 25.8594 34.1235 26.0844 33.5001H21.125C20.7219 33.5001 20.3469 33.2845 20.1454 32.9329C19.9438 32.5813 19.9485 32.1501 20.1547 31.8032L22.6157 27.6548C23.225 26.6282 24.3266 26.0001 25.5172 26.0001H29.375C29.4875 25.8126 29.6 25.6391 29.7125 25.4704C33.5516 19.8079 39.2704 19.6204 42.6829 20.2485C43.2266 20.347 43.6485 20.7735 43.7516 21.3173C44.3797 24.7345 44.1875 30.4485 38.5297 34.2876C38.3657 34.4001 38.1875 34.5126 38 34.6251V38.4829C38 39.6735 37.3719 40.7798 36.3454 41.3845L32.1969 43.8454C31.85 44.0516 31.4188 44.0563 31.0672 43.8548C30.7157 43.6532 30.5 43.2829 30.5 42.8751V37.8501C29.8391 38.0798 29.2625 38.2673 28.8266 38.4079C28.3016 38.5766 27.7297 38.4313 27.336 38.0423H27.3407ZM38 27.8751C39.0349 27.8751 39.875 27.0349 39.875 26.0001C39.875 24.9652 39.0349 24.1251 38 24.1251C36.9652 24.1251 36.125 24.9652 36.125 26.0001C36.125 27.0349 36.9652 27.8751 38 27.8751Z",
    fill: "#092E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJoinRocket);
export default __webpack_public_path__ + "static/media/ic_join_rocket.cddb03ed141ac070a6ab306bd5af52b1.svg";
export { ForwardRef as ReactComponent };